import { TimelineResolution } from "./TimelineResolution";
import { WorkType } from "./Dto/AddActivityDto";
import { Cell } from "./Table/Cell";

export class UndoItem {
	constructor(public resolution: TimelineResolution, public workType: WorkType, public idx: number, public cells: Array<{Cell: Cell, ColumnIndex: number, Value: number}>) { }
}